import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-widest",
  {
    variants: {
      variant: {
        default: "bg-[var(--color-surface-2)] text-[var(--color-text-secondary)]",
        critical:
          "bg-[var(--color-critical)]/12 text-[var(--color-critical)] border border-[var(--color-critical)]/30",
        urgent:
          "bg-[var(--color-urgent)]/12 text-[var(--color-urgent)] border border-[var(--color-urgent)]/30",
        stable:
          "bg-[var(--color-stable)]/12 text-[var(--color-stable)] border border-[var(--color-stable)]/30",
        info: "bg-[var(--color-info)]/12 text-[var(--color-info)] border border-[var(--color-info)]/30",
        gold: "bg-[var(--color-gold)]/15 text-[var(--color-gold)] border border-[var(--color-gold)]/30",
        outline:
          "border border-[var(--color-border-strong)] text-[var(--color-text-secondary)]",
      },
      size: {
        default: "h-6 px-2.5",
        sm: "h-5 px-2 text-[10px]",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({
  className,
  variant,
  size,
  ...props
}: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size }), className)} {...props} />
  );
}

export { badgeVariants };
